// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body,html {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  background-color: #4c2c90 !important;\n  overflow: hidden;\n}\n\nbody {\n  user-select: none;\n}\n\n#app {\n  width: 100%;\n  height: 100%;\n  background: #fff;\n}\n\n.firebaseui-idp-button {\n  -webkit-tap-highlight-color: transparent;\n}\n", ""]);
// Exports
module.exports = exports;
